
import Http from '@/utils/axios'
import Device from './device'
import { getQueryValue, clearUrlCodeAndReloadPage } from '@/utils'

/**
 * [微信登录，获取openId]
 * @param  {[string]} type [登录类型：1为静默登录，2为获取userInfo登录]
 * @param  {[string]} callback [登录回调，有参数openId为成功，没有则失败]
 * @return {[string]}           [参数值]
 */
export function wechatLogin(type, callback) {
  let merchantCode = getQueryValue('merchant') || '';
  const openId = window.localStorage.getItem(merchantCode + 'openId');
  if(openId) {
    callback && callback(openId);
    return;
  }
  if(Device.isWeixin) {
    let merchant = getQueryValue('merchant');
    let code = getQueryValue('code');
    if (code) {
      Http.post('/api/weixin/getWxInfo', {
        merchantCode: merchant,
        appCode: code
      }).then(res => {
        if(res && res.errorCode === 0) {
          window.localStorage.setItem(merchantCode + 'openId', res.results.openId);
          callback && callback(res.results.openId)
          clearUrlCodeAndReloadPage();
        } else {
          callback && callback()
        }
      },()=>{
        callback && callback()
      })
    } else {
      Http.post('/api/weixin/getWxConfig',{merchant}).then(res => {
        if(res && res.errorCode === 0) {
          let redirectUri = window.encodeURIComponent(window.location.href);
          let snsapiUserinfo = type === 1? 'snsapi_base' : 'snsapi_userinfo'
          if(res.results.appId) {
            let wechatUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.results.appId}&redirect_uri=${redirectUri}&response_type=code&scope=${snsapiUserinfo}&state=STATE#wechat_redirect`
            window.location.href = wechatUrl
          } else {
            callback && callback()
          }

        }
      }, () => {
        callback && callback()
      })
    }
  } else {
    callback && callback();
  }
}

// 注册wxjssdk
export function registerwxsdk(config) {
  return new Promise((resolve, reject) => {
    if (typeof wx != 'undefined') {
      resolve()
    } else {
      const { appId, timestamp, noncestr, signature } = config
      wx.config({
        debug: false,
        appId, // 必填，公众号的唯一标识
        timestamp, // 必填，生成签名的时间戳
        nonceStr: noncestr, // 必填，生成签名的随机串
        signature, // 必填，签名，见附录1
        jsApiList: ['getLocation'], // 需要使用的API列表 见附录2
      })
      wx.ready(function () {
        resolve()
      })
      wx.error(function (res) {
        console.error(res,'微信jssdk注册失败' );
        reject()
      })
    }
  })
}

// 获取wxjssdk 信息
function getwxsdkInfo() {
  return new Promise((resolve, reject) => {
    Http.post('/api/wx/getWxConfigInfo', {
      url: location.origin
    }).then(res => {
      if (res && res.errorCode) {
        reject('获取失败')
        return
      }
      resolve(res.results)
    }, () => {
      reject('获取失败')
    })
  })
}
